import { render } from "./QuizResults.vue?vue&type=template&id=24833331&ts=true"
import script from "./QuizResults.vue?vue&type=script&lang=ts"
export * from "./QuizResults.vue?vue&type=script&lang=ts"

import "./QuizResults.vue?vue&type=style&index=0&id=24833331&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__